<template>
  <div class="$attrs.class">
    <label class="upper">RESOURCES</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="local"
              v-model="local"
              name="local"
              label="Local behavioral health resources that are accessible to students"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text-area
              id="campus"
              v-model="campus"
              name="campus"
              label="On-Campus resources that are accessible to students"
              type="text"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'Resources',

  components: {
    FormComponent,
    InputText,
    InputTextArea,
    InputSelect,
  },

  inject:['school'],

  data() {
    return {
      local: '',
      campus: '',
    }
  },

  mounted() {
    this.local = this.school.resources.local;
    this.campus = this.school.resources.campus;
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid)
        return;

      this.errors.clear();

      try {
        await this.school.updateResources({
          local: this.local,
          campus: this.campus,
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Resources Saved!',
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save resources. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }
</style>